import PropTypes from 'prop-types';
import React from 'react';

import { isLocalURL } from '$utilities/browser';
import { formatLinkBlockToUrl } from '$utilities/format';
import { slugify } from '../../utilities/slugify.js';
import ModuleDispatcher from './module-dispatcher';
import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleSectionBlock = ({
    content,
    ctaLabel,
    ctaUrl,
    heading,
    index,
    sectionBody
}) => {
    // misc
    const href = formatLinkBlockToUrl(ctaUrl);
    const target = isLocalURL(href) ?  '_self' : '_blank';
    const rel = isLocalURL(href) ? null : 'noreferrer noopener';

    // render
    return (
        <>
            <div className='layout-container overflow-hidden'>
                <div className='md:flex mt-40 md:mt-100'>
                    <div className='md:w-1/12' />

                    <div className='sm:w-6/12 md:w-7/12'>
                        {heading && (
                            <h2 className={`type-style-1 pb-15 md:pb-20${index > 0 ? '' : '  pt-30 md:pt-90'}`}>
                                {heading}
                            </h2>
                        )}

                        {sectionBody && (
                            <RichTextWithGlossary
                                className='rich-text type-style-4 pb-25 md:pb-30'
                                html={sectionBody} />
                        )}

                        {ctaLabel && (
                            <div className='pb-40 md:pb-60'>
                                <a
                                    className={`pill-button gtm-${slugify(ctaLabel)}`}
                                    href={href}
                                    rel={rel}
                                    target={target}>
                                    {ctaLabel}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {content?.map((module, idx) => {
                return (
                    <ModuleDispatcher
                        index={idx}
                        isAccordionOrSection={true}
                        key={idx}
                        {...module} />
                );
            })}
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    content: PropTypes.array,
    ctaLabel: PropTypes.string,
    ctaUrl: PropTypes.object,
    heading: PropTypes.string,
    index: PropTypes.number,
    sectionBody: PropTypes.string
};

ModuleSectionBlock.propTypes = propTypes;

export default ModuleSectionBlock;
